import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    SPRAY_EVENTS_LOAD_REQUESTED,
    SPRAY_EVENTS_LOAD_SUCCEEDED,
    SPRAY_EVENTS_LOAD_FAILED,
    SPRAY_EVENTS_LOAD_CANCELED,
    SPRAY_EVENT_CREATE_REQUESTED,
    SPRAY_EVENT_CREATE_SUCCEEDED,
    SPRAY_EVENT_CREATE_FAILED,
    SPRAY_EVENTS_SET,
    SPRAY_EVENTS_DELETE,
    SPRAY_EVENT_SET,
    SPRAY_EVENT_DELETE_REQUESTED,
    SPRAY_EVENT_DELETE_SUCCEEDED,
    SPRAY_EVENT_DELETE_FAILED,
    SPRAY_EVENT_UPDATE_FAILED,
    SPRAY_EVENT_UPDATE_REQUESTED,
    SPRAY_EVENT_UPDATE_SUCCEEDED,
    SPRAY_EVENTS_COMPLETE_REQUESTED,
    SPRAY_EVENTS_COMPLETE_SUCCEEDED,
    SPRAY_EVENTS_COMPLETE_FAILED,
    SPRAY_EVENT_UNCOMPLETE_REQUESTED,
    SPRAY_EVENT_UNCOMPLETE_SUCCEEDED,
    SPRAY_EVENT_UNCOMPLETE_FAILED
} from './constants';

// Types
import {
    SprayEventPostRequestPayload,
    SprayEvent,
    SprayEventsState,
    RequestLoadSprayEventsAction,
    SucceededLoadSprayEventsAction,
    FailedLoadTimesheetsAction,
    CanceledLoadSprayEventsAction,
    RequestCreateSprayEventAction,
    SucceededCreateSprayEventAction,
    FailedCreateTimesheetAction,
    SetSprayEventsAction,
    DeleteSprayEventsAction,
    SetSprayEventAction,
    RequestDeleteSprayEventAction,
    FailedDeleteSprayEventAction,
    SucceededDeleteSprayEventAction,
    FailedUpdateTimesheetAction,
    SucceededUpdateSprayEventAction,
    RequestUpdateSprayEventAction,
    SprayEventPatchRequestPayload,
    SprayEventUuid,
    RequestCompleteSprayEventsAction,
    SucceededCompleteSprayEventsAction,
    FailedCompleteSprayEventsAction,
    RequestUncompleteSprayEventAction,
    SucceededUncompleteSprayEventAction,
    FailedUncompleteSprayEventAction,
    SprayEventWeather,
    SprayEventDisposal
} from './types';

export function requestLoadSprayEvents(): RequestLoadSprayEventsAction {
    return {
        type: SPRAY_EVENTS_LOAD_REQUESTED
    };
}

export function succeededLoadSprayEvents(
    response: AxiosResponse
): SucceededLoadSprayEventsAction {
    return {
        type: SPRAY_EVENTS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSprayEvents(
    error: AxiosError
): FailedLoadTimesheetsAction {
    return {
        type: SPRAY_EVENTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadSprayEvents(): CanceledLoadSprayEventsAction {
    return {
        type: SPRAY_EVENTS_LOAD_CANCELED
    };
}

export function requestCreateSprayEvent(
    sprayEvent: SprayEventPostRequestPayload
): RequestCreateSprayEventAction {
    return {
        type: SPRAY_EVENT_CREATE_REQUESTED,
        payload: sprayEvent
    };
}

export function succeededCreateSprayEvent(
    response: AxiosResponse
): SucceededCreateSprayEventAction {
    return {
        type: SPRAY_EVENT_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateSprayEvent(
    error: AxiosError
): FailedCreateTimesheetAction {
    return {
        type: SPRAY_EVENT_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateSprayEvent(
    sprayEvent: SprayEventPatchRequestPayload
): RequestUpdateSprayEventAction {
    return {
        type: SPRAY_EVENT_UPDATE_REQUESTED,
        payload: sprayEvent
    };
}

export function succeededUpdateSprayEvent(
    response: AxiosResponse
): SucceededUpdateSprayEventAction {
    return {
        type: SPRAY_EVENT_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateSprayEvent(
    error: AxiosError
): FailedUpdateTimesheetAction {
    return {
        type: SPRAY_EVENT_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function setSprayEvents(
    sprayEvents: SprayEventsState
): SetSprayEventsAction {
    return {
        type: SPRAY_EVENTS_SET,
        payload: sprayEvents
    };
}

export function deleteSprayEvents(
    uuids: SprayEventUuid[]
): DeleteSprayEventsAction {
    return {
        type: SPRAY_EVENTS_DELETE,
        payload: {
            uuids
        }
    };
}

export function setSprayEvent(sprayEvent: SprayEvent): SetSprayEventAction {
    return {
        type: SPRAY_EVENT_SET,
        payload: sprayEvent
    };
}

export function requestDeleteSprayEvent(
    uuids: SprayEventUuid[]
): RequestDeleteSprayEventAction {
    return {
        type: SPRAY_EVENT_DELETE_REQUESTED,
        payload: {
            uuids
        }
    };
}

export function succeededDeleteSprayEvent(
    uuids: SprayEventUuid[]
): SucceededDeleteSprayEventAction {
    return {
        type: SPRAY_EVENT_DELETE_SUCCEEDED,
        payload: {
            uuids
        }
    };
}

export function failedDeleteSprayEvent(
    error: AxiosError
): FailedDeleteSprayEventAction {
    return {
        type: SPRAY_EVENT_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function requestCompleteSprayEvents(
    uuids: SprayEventUuid[],
    weatherUuids?: Record<SprayEventUuid, SprayEventWeather>,
    disposalUuids?: Record<SprayEventUuid, SprayEventDisposal>
): RequestCompleteSprayEventsAction {
    return {
        type: SPRAY_EVENTS_COMPLETE_REQUESTED,
        payload: {
            uuids,
            weatherUuids,
            disposalUuids
        }
    };
}

export function succeededCompleteSprayEvents(): SucceededCompleteSprayEventsAction {
    return {
        type: SPRAY_EVENTS_COMPLETE_SUCCEEDED
    };
}

export function failedCompleteSprayEvents(
    error: AxiosError
): FailedCompleteSprayEventsAction {
    return {
        type: SPRAY_EVENTS_COMPLETE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUncompleteSprayEvent(
    uuid: SprayEventUuid
): RequestUncompleteSprayEventAction {
    return {
        type: SPRAY_EVENT_UNCOMPLETE_REQUESTED,
        payload: {
            uuid
        }
    };
}

export function succeededUncompleteSprayEvent(
    response: AxiosResponse
): SucceededUncompleteSprayEventAction {
    return {
        type: SPRAY_EVENT_UNCOMPLETE_SUCCEEDED,
        payload: response
    };
}

export function failedUncompleteSprayEvent(
    error: AxiosError
): FailedUncompleteSprayEventAction {
    return {
        type: SPRAY_EVENT_UNCOMPLETE_FAILED,
        payload: error,
        error: true
    };
}
